import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  code: string;
}

const FlowStatusBadge: React.FC<Props> = ({ code }) => {
  const { t } = useTranslation();

  return (
    <div className={`badge-base flowstatus ${code}`}>
      <div className="badge-text">
        <span>{t(`flowStatusCodes.${code}`)}</span>
      </div>
    </div>
  );
};

export default React.memo(FlowStatusBadge);
